import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

function Footer() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();
  const location = useLocation();
  const isAboutPage = location.pathname === '/about';

  // Simplified footer for About page
  if (isAboutPage) {
    return (
      <footer className="footer footer-simple">
        <div className="container">
          <div className="footer-bottom">
            <p>
              &copy; {currentYear} by Sven Giegerich. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    );
  }

  // Default footer for all other pages
  return (
    <footer className="footer footer-redesigned">
      <div className="container">
        <div className="footer-bottom">
          <p>&copy; {currentYear} by Sven Giegerich</p>
          <span className="footer-separator">|</span>
          <p className="footer-dedication">{t('auth.dedication')}</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
